import { defineMessages } from "react-intl";
import { customerConfig } from '../config';

// The argument to defineMessages has to be an object literal. If you try to create the argument programmatically it
// doesn't work https://github.com/yahoo/babel-plugin-react-intl/issues/78
//
// The key names are irrelevant, so choose something something short (e.g. numbers)

let k = 0;
const commonAppName = "ScanStation";
const commonServiceAreaTitle = "Where do you want your information to go?";
const commonEvidenceAreaTitle = "Which type of evidence are you providing?";
const commonSubmissionType = "Evidence Type";
const commonSubmissionTitle = "Evidence Submitted";
const commonSubmissionSuccessMsg = "You have successfully submitted evidence for:";

defineMessages({
  [++k]: {id: 'yes', defaultMessage: 'Yes'},
  [++k]: {id: 'no', defaultMessage: 'No'},
  [++k]: {id: 'addImages', defaultMessage: 'Add Images'},

  [++k]: {id: 'customer.broxbourne', defaultMessage: 'Borough of Broxbourne Council'},
  [++k]: {id: 'customer.broxbourne.appType', defaultMessage: commonAppName},
  [++k]: {id: 'customer.broxbourne.serviceAreaTitle', defaultMessage: commonServiceAreaTitle},
  [++k]: {id: 'customer.broxbourne.evidenceAreaTitle', defaultMessage: commonEvidenceAreaTitle},
  [++k]: {id: 'customer.broxbourne.submissionType', defaultMessage: commonSubmissionType},
  [++k]: {id: 'customer.broxbourne.submissionTitle', defaultMessage: commonSubmissionTitle},
  [++k]: {id: 'customer.broxbourne.submissionSuccessMsg', defaultMessage: commonSubmissionSuccessMsg},

  [++k]: {id: 'customer.darlington', defaultMessage: 'Darlington Borough Council'},
  [++k]: {id: 'customer.darlington.appType', defaultMessage: commonAppName},
  [++k]: {id: 'customer.darlington.serviceAreaTitle', defaultMessage: commonServiceAreaTitle},
  [++k]: {id: 'customer.darlington.evidenceAreaTitle', defaultMessage: commonEvidenceAreaTitle},
  [++k]: {id: 'customer.darlington.submissionType', defaultMessage: commonSubmissionType},
  [++k]: {id: 'customer.darlington.submissionTitle', defaultMessage: commonSubmissionTitle},
  [++k]: {id: 'customer.darlington.submissionSuccessMsg', defaultMessage: commonSubmissionSuccessMsg},

  [++k]: {id: 'customer.demo', defaultMessage: 'Demo'},
  [++k]: {id: 'customer.demo.appType', defaultMessage: commonAppName},
  [++k]: {id: 'customer.demo.serviceAreaTitle', defaultMessage: commonServiceAreaTitle},
  [++k]: {id: 'customer.demo.evidenceAreaTitle', defaultMessage: commonEvidenceAreaTitle},
  [++k]: {id: 'customer.demo.submissionType', defaultMessage: commonSubmissionType},
  [++k]: {id: 'customer.demo.submissionTitle', defaultMessage: commonSubmissionTitle},
  [++k]: {id: 'customer.demo.submissionSuccessMsg', defaultMessage: commonSubmissionSuccessMsg},

  [++k]: {id: 'customer.hull', defaultMessage: 'Hull City Council'},
  [++k]: {id: 'customer.hull.appType', defaultMessage: commonAppName},
  [++k]: {id: 'customer.hull.serviceAreaTitle', defaultMessage: commonServiceAreaTitle},
  [++k]: {id: 'customer.hull.evidenceAreaTitle', defaultMessage: commonEvidenceAreaTitle},
  [++k]: {id: 'customer.hull.submissionType', defaultMessage: commonSubmissionType},
  [++k]: {id: 'customer.hull.submissionTitle', defaultMessage: commonSubmissionTitle},
  [++k]: {id: 'customer.hull.submissionSuccessMsg', defaultMessage: commonSubmissionSuccessMsg},

  [++k]: {id: 'customer.kirklees', defaultMessage: 'Kirklees Council'},
  [++k]: {id: 'customer.kirklees.appType', defaultMessage: commonAppName},
  [++k]: {id: 'customer.kirklees.serviceAreaTitle', defaultMessage: commonServiceAreaTitle},
  [++k]: {id: 'customer.kirklees.evidenceAreaTitle', defaultMessage: commonEvidenceAreaTitle},
  [++k]: {id: 'customer.kirklees.submissionType', defaultMessage: commonSubmissionType},
  [++k]: {id: 'customer.kirklees.submissionTitle', defaultMessage: commonSubmissionTitle},
  [++k]: {id: 'customer.kirklees.submissionSuccessMsg', defaultMessage: commonSubmissionSuccessMsg},

  [++k]: {id: 'customer.leicester', defaultMessage: 'Leicester City Council'},
  [++k]: {id: 'customer.leicester.appType', defaultMessage: commonAppName},
  [++k]: {id: 'customer.leicester.serviceAreaTitle', defaultMessage: commonServiceAreaTitle},
  [++k]: {id: 'customer.leicester.evidenceAreaTitle', defaultMessage: commonEvidenceAreaTitle},
  [++k]: {id: 'customer.leicester.submissionType', defaultMessage: commonSubmissionType},
  [++k]: {id: 'customer.leicester.submissionTitle', defaultMessage: commonSubmissionTitle},
  [++k]: {id: 'customer.leicester.submissionSuccessMsg', defaultMessage: commonSubmissionSuccessMsg},

  [++k]: {id: 'customer.northgate', defaultMessage: "Northgate"},
  [++k]: {id: 'customer.northgate.appType', defaultMessage: commonAppName},
  [++k]: {id: 'customer.northgate.serviceAreaTitle', defaultMessage: commonServiceAreaTitle},
  [++k]: {id: 'customer.northgate.evidenceAreaTitle', defaultMessage: commonEvidenceAreaTitle},
  [++k]: {id: 'customer.northgate.submissionType', defaultMessage: commonSubmissionType},
  [++k]: {id: 'customer.northgate.submissionTitle', defaultMessage: commonSubmissionTitle},
  [++k]: {id: 'customer.northgate.submissionSuccessMsg', defaultMessage: commonSubmissionSuccessMsg},

  [++k]: {id: 'customer.preston', defaultMessage: "Preston City Council"},
  [++k]: {id: 'customer.preston.appType', defaultMessage: commonAppName},
  [++k]: {id: 'customer.preston.serviceAreaTitle', defaultMessage: commonServiceAreaTitle},
  [++k]: {id: 'customer.preston.evidenceAreaTitle', defaultMessage: commonEvidenceAreaTitle},
  [++k]: {id: 'customer.preston.submissionType', defaultMessage: commonSubmissionType},
  [++k]: {id: 'customer.preston.submissionTitle', defaultMessage: commonSubmissionTitle},
  [++k]: {id: 'customer.preston.submissionSuccessMsg', defaultMessage: commonSubmissionSuccessMsg},

  [++k]: {id: 'customer.rushcliffe', defaultMessage: "Rushcliffe Borough Council"},
  [++k]: {id: 'customer.rushcliffe.appType', defaultMessage: commonAppName},
  [++k]: {id: 'customer.rushcliffe.serviceAreaTitle', defaultMessage: commonServiceAreaTitle},
  [++k]: {id: 'customer.rushcliffe.evidenceAreaTitle', defaultMessage: commonEvidenceAreaTitle},
  [++k]: {id: 'customer.rushcliffe.submissionType', defaultMessage: commonSubmissionType},
  [++k]: {id: 'customer.rushcliffe.submissionTitle', defaultMessage: commonSubmissionTitle},
  [++k]: {id: 'customer.rushcliffe.submissionSuccessMsg', defaultMessage: commonSubmissionSuccessMsg},

  [++k]: {id: 'customer.slough', defaultMessage: "Slough Borough Council"},
  [++k]: {id: 'customer.slough.appType', defaultMessage: commonAppName},
  [++k]: {id: 'customer.slough.serviceAreaTitle', defaultMessage: commonServiceAreaTitle},
  [++k]: {id: 'customer.slough.evidenceAreaTitle', defaultMessage: commonEvidenceAreaTitle},
  [++k]: {id: 'customer.slough.submissionType', defaultMessage: commonSubmissionType},
  [++k]: {id: 'customer.slough.submissionTitle', defaultMessage: commonSubmissionTitle},
  [++k]: {id: 'customer.slough.submissionSuccessMsg', defaultMessage: commonSubmissionSuccessMsg},

  [++k]: {id: 'imgAlt.upload', defaultMessage: "Upload Icon"},
  [++k]: {id: 'imgAlt.rotate', defaultMessage: "Rotate"},
  [++k]: {id: 'imgAlt.preview', defaultMessage: "Preview"},
  [++k]: {id: 'imgAlt.logo', defaultMessage: "Logo"},
  [++k]: {id: 'receipt.emailAndPhone', defaultMessage: 'A receipt has been sent to the email and phone number provided'},
  [++k]: {id: 'receipt.email', defaultMessage: 'A receipt has been sent to the email address provided'},
  [++k]: {id: 'receipt.phone', defaultMessage: 'A text message receipt has been sent to the phone number provided'},
  [++k]: {id: 'imageUpload.fileTypeError', defaultMessage: ' is not a supported image type. Only JPEG and PNG images are allowed.'},
  [++k]: {id: 'imageUpload.fileSizeError', defaultMessage: " file size is too big"},
  [++k]: {id: 'evidence.notSubmitted', defaultMessage: "Evidence submission failed, please try again"},
  [++k]: {id: 'field.address.error', defaultMessage: "Enter your complete UK address, including a postcode"},
  [++k]: {id: 'field.address.title', defaultMessage: "Address"},
  [++k]: {id: 'field.addressRef.title', defaultMessage: "Address reference"},
  [++k]: {id: 'field.addressPostcode.help', defaultMessage: 'Type your postcode and choose one of the addresses shown. If your address is not shown, enter your complete UK address.'},
  [++k]: {id: 'field.addressPostcode.placeholder', defaultMessage: 'Enter your postcode if you want address suggestions'},
  [++k]: {id: 'field.address.help', defaultMessage: 'Start typing your address and choose one of the addresses shown. If your address is not shown, enter your complete UK address.'},
  [++k]: {id: 'field.images.error', defaultMessage: "You must choose at least one image"},
  [++k]: {id: 'field.images.title', defaultMessage: "Evidence"},
  [++k]: {id: 'searchPlaceholder', defaultMessage: "Search..."},
  [++k]: {id: 'noSearchResults', defaultMessage: 'No matching addresses found'},
  [++k]: {id: 'noAddress', defaultMessage: 'I have no current address'},
});

let LANG = 'en';

if (customerConfig.translations) {
  // Different browsers have the user locale defined on different fields of the navigator object,
  // so we make sure to account for these differences by checking all of them.
  let browserLanguage = (navigator.languages && navigator.languages[0]) || navigator.language || navigator.userLanguage;
  browserLanguage = browserLanguage.toLowerCase().split(/[_-]+/)[0];

  if (customerConfig.translations.indexOf(browserLanguage) > -1) {
    LANG = browserLanguage;
  }
}

const IS_DEFAULT_LANG = LANG === 'en';

export default {

  /**
   * Returns a function that retrieves a message for the current locale
   * @param intl
   * @returns {function(*=): *}
   */
  getMsg(intl) {
    return (key, allowMissingId) => {

      const args = {id: key};

      // By default, if we try to translate a message key that doesn't exist, an error will be shown in the console (in
      // the dev env). But on some occasions, we attempt to translate a key that may or may not exist. In this case, we
      // don't want to show an error if the translation fails
      if (allowMissingId) {
        args.defaultMessage = key;
      }
      return intl.formatMessage(args);
    }
  },

  LANG,

  /**
   * Translate one-or-more properties in-place
   * @param entity
   * @param properties
   * @returns {*}
   */
  translate(entity, properties = ['label']) {

    if (!IS_DEFAULT_LANG) {
      properties.forEach(property => {

        if (entity.hasOwnProperty(property)) {
          // replace (for example) the English label with the Welsh label
          entity[property] = entity[`${property}-${LANG}`] || entity[property];
        }
      });
    }
    return entity;
  },

  /**
   * Get the translation of a property
   * @param object
   * @param property
   * @returns {*}
   */
  getTranslation(object, property = 'label') {
    const translationKey = `${property}-${LANG}`;

    if (!IS_DEFAULT_LANG && object.hasOwnProperty(translationKey)) {
      return object[translationKey]
    }
    return object[property];
  }
};
